export class OfflineModelInstance
{
    id?: number;
    table: string;
    key: number;
    created_at: Date;
}